import { MixpanelWizardStep } from 'redux/modules/mixpanel/types';
import { Step } from './types';

export const MIXPANEL_WIZARD_STEP_MAP: Record<Step, MixpanelWizardStep> = {
  aspectRatio: 'Choose Aspect Ratio',
  submitting: 'loading',
};
